<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { isDark } from '@/utils/is'
import { setCSSVariable, isMobile } from '@/utils/index'
import { useDesign } from '@/hooks/web/useDesign'
import { useStorage } from '@/hooks/web/useStorage'

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

const { getStorage } = useStorage()

// 根据浏览器当前主题设置系统主题色
const setDefaultTheme = () => {
  if (getStorage('isDark') !== null) {
    appStore.setIsDark(getStorage('isDark'))
    return
  }
  const isDarkTheme = isDark()
  appStore.setIsDark(isDarkTheme)
}

onMounted(() => {
  if (isMobile()) {
    setCSSVariable('--app-content-padding', '0px')
  }
})

// setDefaultTheme()
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

ul {
  padding: 0;
}

li {
  list-style: none;
}

@media (max-width: 767px)  {
  .el-card .el-card__body {
    padding: 10px;
  }
}
@media (min-width: 768px)  {
  .el-card .el-card__body {
    padding: 20px;
  }
}

.el-input {
  --el-input-width: 220px;
}

.el-select {
  --el-select-width: 220px;
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
